module.exports = __webpack_public_path__ + "static/img/24b1ad6fd2220e67e1e736569a649cf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon3(3).jpg
// module id = GvWe
// module chunks = 1